import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M12.806 2.194C9.881-.731 5.12-.731 2.194 2.194c-2.925 2.926-2.925 7.686 0 10.612 2.926 2.925 7.686 2.925 10.612 0 2.925-2.926 2.925-7.686 0-10.612\" fill=\"#9F9F9F\" /><g stroke=\"#FFF\" stroke-linecap=\"round\"><path d=\"M10.563 4.438l-6.188 6.187M4.438 4.438l6.187 6.187\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol